import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Loader2, Search, Car } from "lucide-react";

const WizardStepVehicle = ({ form, updateField, vehicleFound, matchedLoan, vLookupLoading, onVehicleLookup }) => {
  return (
  <div className="space-y-4" data-testid="wizard-step-vehicle">
    <div>
      <Label className="text-xs font-medium text-slate-600">Fastnúmer / Bílnúmer</Label>
      <div className="flex gap-2 mt-1">
        <Input
          value={form.vehicle.fastanumer || ""}
          onChange={(e) => {
            const v = e.target.value.toUpperCase();
            updateField("vehicle", "fastanumer", v);
            updateField("vehicle", "registrationNumber", v);
          }}
          onKeyDown={(e) => e.key === "Enter" && onVehicleLookup()}
          placeholder="t.d. SEN14"
          className="h-9 text-sm font-mono uppercase"
          data-testid="wizard-fastanumer"
        />
        <Button onClick={onVehicleLookup} disabled={vLookupLoading} size="sm" className="h-9 px-3" data-testid="wizard-vehicle-lookup">
          {vLookupLoading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Search className="h-4 w-4" />}
        </Button>
      </div>
    </div>
    {(vehicleFound || form.vehicle.displayName) && (
      <div className="bg-slate-50 rounded-lg p-3 border space-y-2" data-testid="wizard-vehicle-info">
        <div className="flex items-center gap-2">
          <Car className="h-4 w-4 text-blue-600" />
          <span className="text-sm font-semibold">{form.vehicle.displayName || `${form.vehicle.manufacturer} ${form.vehicle.model}`}</span>
          {form.vehicle.subtype && <span className="text-xs text-slate-500">— {form.vehicle.subtype}</span>}
        </div>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1 text-xs text-slate-600">
          {form.vehicle.firstRegistration && <div>Fyrst skráð: {form.vehicle.firstRegistration}</div>}
          {form.vehicle.vin && <div>VIN: {form.vehicle.vin}</div>}
          {form.vehicle.color && <div>Litur: {form.vehicle.color}</div>}
          {form.vehicle.ownerName && <div>Eigandi: <span className="font-medium text-slate-800">{form.vehicle.ownerName}</span></div>}
          {form.insurance?.sellerInsurer && <div>Trygging: {form.insurance.sellerInsurer}</div>}
          {form.vehicle.mileage && <div>Km staða: <span className="font-medium text-slate-800">{Number(form.vehicle.mileage).toLocaleString("de-DE")} km</span>{form.vehicle.mileageSource === "creditinfo" && <span className="text-green-600 ml-1">(Creditinfo)</span>}</div>}
        </div>
        {matchedLoan && <Badge variant="secondary" className="text-[10px]">{matchedLoan}</Badge>}
      </div>
    )}
    <div className="grid grid-cols-2 gap-3">
      <div>
        <Label className="text-xs text-slate-600">Framleiðandi</Label>
        <Input value={form.vehicle.manufacturer || ""} onChange={(e) => updateField("vehicle", "manufacturer", e.target.value)} className="h-8 text-sm mt-1" data-testid="wizard-manufacturer" />
      </div>
      <div>
        <Label className="text-xs text-slate-600">Gerð</Label>
        <Input value={form.vehicle.model || ""} onChange={(e) => updateField("vehicle", "model", e.target.value)} className="h-8 text-sm mt-1" data-testid="wizard-model" />
      </div>
    </div>
    <div className="grid grid-cols-2 gap-3">
      <div>
        <Label className="text-xs text-slate-600">Akstur</Label>
        <div className="relative">
          <Input value={form.vehicle.mileage || ""} onChange={(e) => updateField("vehicle", "mileage", e.target.value)} placeholder="km" className="h-8 text-sm mt-1" data-testid="wizard-mileage" />
          {form.vehicle.mileageSource === "creditinfo" && <span className="absolute right-2 top-1/2 -translate-y-1/2 mt-0.5 text-[9px] text-emerald-600 font-medium">Creditinfo</span>}
        </div>
      </div>
      <div>
        <Label className="text-xs text-slate-600">Árgerð</Label>
        <Input value={form.vehicle.modelYear || ""} onChange={(e) => updateField("vehicle", "modelYear", e.target.value)} className="h-8 text-sm mt-1" data-testid="wizard-year" />
      </div>
    </div>
  </div>
  );
};

export default WizardStepVehicle;
